import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { OPERATORY_COLORS } from '../constant';

type Props = {
  value: string;
  onChange: (color: string) => void;
};

export const AvatarColorList = ({ value, onChange }: Props) => {
  return (
    <div css={colorListContainer}>
      {OPERATORY_COLORS.map((opColor) => (
        <div key={opColor} css={colorIconContainer(value === opColor)}>
          <div onClick={() => onChange(opColor)} css={colorIconStyle(opColor)}>
            {value === opColor && <Icon name='check-small' />}
          </div>
        </div>
      ))}
    </div>
  );
};

const colorListContainer = css({
  display: 'flex',
  flexWrap: 'wrap',
  borderBottom: `1px solid ${theme.colors.neutral20}`,
  paddingBottom: theme.spacing(1),
});

const colorIconContainer = (isSelected: boolean) =>
  css({
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: theme.borderRadius.full,
    ...(isSelected && {
      border: `2px solid ${theme.colors.primary50}`,
    }),
  });

const colorIconStyle = (color: string) =>
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: color,
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
    borderRadius: theme.borderRadius.full,
    border: `1px solid ${theme.colors.neutral20}`,
  });
